import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const token = auth.token();
  const isAuthCall =
    req.url.includes('/auth/admin/login') ||
    req.url.includes('/auth/citizen/') ||
    req.url.includes('/auth/officer/login');
  // Logout still needs the bearer token so the server can revoke it, but a 401
  // here means the token was already dead — reporting that as an expired
  // session would be wrong on a logout the user asked for.
  const isLogoutCall =
    req.url.includes('/auth/admin/logout') || req.url.includes('/auth/officer/logout');
  // A 401 from the password form means the typed current password was wrong,
  // not that the session died. Signing the user out here would replace that
  // error with a bogus "session expired" bounce to the login page.
  const isPasswordCheck = req.url.includes('/auth/change-password');
  // Boot restore uses this probe. A dead leftover token must not yank the
  // public landing page over to /login — AuthService just drops the session.
  const isSessionProbe = req.url.includes('/auth/session');

  const authedReq =
    !token || isAuthCall
      ? req
      : req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });

  return next(authedReq).pipe(
    catchError((err: unknown) => {
      if (
        err instanceof HttpErrorResponse
        && err.status === 401
        && !isAuthCall
        && !isLogoutCall
        && !isPasswordCheck
        && !isSessionProbe
      ) {
        auth.clearLocalSession();
        void router.navigate(['/login'], { queryParams: { reason: 'session' } });
      }
      return throwError(() => err);
    }),
  );
};
